import { DUEL_CLOCK_URGENT_MS } from '@shared/index'

/** `m:ss` for the PvP chess clock. */
export function formatDuelClock(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000))
  const m = Math.floor(total / 60)
  const s = total % 60
  return `${m}:${s.toString().padStart(2, '0')}`
}

export function isDuelClockUrgent(ms: number): boolean {
  return ms <= DUEL_CLOCK_URGENT_MS
}
